import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import RichObjectTreeView from './TreeView' // Assuming RichObjectTreeView component is imported
import Modal from '../../../components/Modal'
import TestIds from '../../../testIds'
import { useSelector } from 'react-redux'
import { selectDeclarations, selectDeclarationsStatus } from '../declarations.slice'
import { Loader } from '../../../components/Loader'
import apiClient from '../../../services/api-client'
import { Theme, useMediaQuery } from '@mui/material'

import { Capacitor } from '@capacitor/core'
import { Browser } from '@capacitor/browser'
import { isIOS, isMacOs } from 'react-device-detect'

type DeclarationModalProps = {
  open: boolean
  handleClose: () => void
}

const DeclarationModal = ({ open, handleClose }: DeclarationModalProps) => {
  const declarations = useSelector(selectDeclarations)
  const status = useSelector(selectDeclarationsStatus)

  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'))
  const onRequestDownload = async (path: string) => {
    const response = await apiClient.get<string, { path: string }>(
      `/declarations/link?file=${path}`,
    )

    if (Capacitor.isNativePlatform()) {
      Browser.open({
        url: response.data,
        toolbarColor: '#004733',
      })
    } else if (isIOS || isMacOs) {
      setTimeout(() => {
        window.open(response.data, '_blank')
      })
    } else {
      window.open(response.data, '_blank')
    }
  }
  const memo = React.useMemo(() => {
    if (status === 'pending') {
      return (
        <Box height='100%' display='flex' minHeight='540px'>
          <Loader title='Loading declarations' margin='auto' />
        </Box>
      )
    } else if (declarations) {
      const paths = declarations?.declarations.map((d) => d.path)
      return (
        <>
          <Box display='flex' justifyContent={'space-between'} mb={2}>
            <Typography variant='body2' fontWeight={'bold'} alignSelf='left'>
              Name
            </Typography>
          </Box>
          <RichObjectTreeView paths={paths} onClick={onRequestDownload} />
        </>
      )
    } else {
      return <Typography variant='body2'>No declarations found</Typography>
    }
  }, [status, declarations])

  if (open)
    return (
      <Modal
        fullWidth
        fullScreen={isMobile}
        maxWidth='md'
        onClick={(e) => e.stopPropagation()}
        open={open}
        handleClose={handleClose}
        title='Feed declarations'
        testId={TestIds.feat.declarations.modal}
      >
        {memo}
      </Modal>
    )
}

export default DeclarationModal
